<template>
  <v-dialog :value="value" max-width="800px" persistent scrollable>
    <v-card class="kbLight pb-0">
      <v-toolbar class="kbBlue" dark flat>
        <div class="text-h6">{{$t('general.addCreditCard')}}</div>
        <v-spacer></v-spacer>
        <v-btn icon @click="toggleModal()">
          <v-icon>clear</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-form ref="form">
          <v-row>
            <v-col cols="12"
                   class="d-flex justify-center">
              <div class="d-flex flex-column align-center">
                <v-icon color="kbBlue"
                        class="mb-1"
                        size="80px">
                  mdi-credit-card
                </v-icon>
                <span class="kbDarkBlueText--text text-h5 font-weight-medium">
                {{ $t('general.addCreditCard') }}
              </span>
              </div>
            </v-col>
            <v-col cols="12" class="pb-0">
            <span class="kbDarkBlueText--text text-subtitle-1 font-weight-medium d-block mb-1">
              {{ $t('general.cardNumber') }}
            </span>
              <card-number class="stripe-element card-number"
                           ref="cardNumber"
                           :stripe="stripeKey"
                           :options="componentOptions"
                           @change="number = $event.complete"
              />
            </v-col>

            <v-col cols="12" md="6" class="pb-0">
            <span class="kbDarkBlueText--text text-subtitle-1 font-weight-medium d-block mb-1">
              {{ $t('general.cardExpirationDate') }}
            </span>
              <card-expiry class="stripe-element card-expiry"
                           ref="cardExpiry"
                           :stripe="stripeKey"
                           :options="componentOptions"
                           @change="expiry = $event.complete"
              />
            </v-col>

            <v-col cols="12" md="6" class="pb-0">
            <span class="kbDarkBlueText--text text-subtitle-1 font-weight-medium d-block mb-1">
              CVC
            </span>
              <card-cvc class="stripe-element card-cvc"
                        ref="cardCvc"
                        :stripe="stripeKey"
                        :options="componentOptions"
                        @change="cvc = $event.complete"
              />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red"
               class="mr-1"
               outlined
               @click="toggleModal()">
          {{ $t('general.cancel') }}
        </v-btn>

        <v-btn color="kbBlue"
               dark
               @click="submit()"
               :loading="loadingAddCreditCard">
          {{ $t('general.add') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
// yjch-gopu-rjjx-icxa-uugz
import { CardNumber, CardExpiry, CardCvc, createToken } from 'vue-stripe-elements-plus'
import notifications from '@/libs/notifications'
import { EventBus } from '@/eventBus'
export default {
  components: { CardNumber, CardExpiry, CardCvc },
  computed: {
    componentOptions () {
      const vue = this
      const styles = {
        base: {
          color: vue.$vuetify.theme.isDark ? '#FFFFFF' : '#172B4D',
          fontSize: '16px',
          fontFamily: 'Roboto, sans-serif',
          fontSmoothing: 'antialiased',
          fontWeight: '500',
          lineHeight: '24px',
          '::placeholder': { color: vue.$vuetify.theme.isDark ? '#FFFFFF' : '#172B4D' },
          ':-webkit-autofill': { color: vue.$vuetify.theme.isDark ? '#FFFFFF' : '#172B4D' }
        },
        complete: {
          color: '#4CAF50',
          iconColor: '#4CAF50',
          ':-webkit-autofill': { color: '#4CAF50' }
        },
        invalid: {
          color: '#F53C56',
          iconColor: '#F53C56',
          ':-webkit-autofill': { color: '#F53C56' }
        }
      }
      return {
        style: styles,
        classes: {
          base: 'form-stripe-element',
          focus: 'form-stripe-element--focus',
          disabled: 'form-stripe-element--disabled',
          complete: 'form-stripe-element--is-success',
          invalid: 'form-stripe-element--is-error',
          empty: 'form-stripe-element'
        }
      }
    }
  },
  created () {
    EventBus.$on('openAddNewCreditCardDialog', () => {
      this.$emit('input', true)
    })
  },
  data () {
    return {
      cardNumberElement: {},
      cardExpiryElement: {},
      cardCvcElement: {},
      complete: false,
      loadingAddCreditCard: false,
      number: false,
      expiry: false,
      cvc: false,
      stripeKey: process.env.VUE_APP_STRIPE_API_KEY
    }
  },
  methods: {
    clearInputs () {
      this.$refs.cardNumber.clear()
      this.$refs.cardCvc.clear()
      this.$refs.cardExpiry.clear()
    },
    async submit () {
      if (!this.complete) return notifications.error('You must fill all the fields correctly')
      try {
        this.loadingAddCreditCard = true
        const createTokenResponse = await createToken()
        const cardToken = createTokenResponse.token.id
        await this.$store.dispatch('addCreditCardStripe', {
          cardToken,
          transactionProvider: 'stripe'
        })
        this.loadingAddCreditCard = false
        notifications.success(this.$t('general.creditCardSuccessfullyAdded'))
        this.toggleModal()
      } catch (e) {
        this.loadingAddCreditCard = false
        console.log(e)
      }
    },
    toggleModal () {
      this.$emit('input', false)
      this.clearInputs()
    },
    update () {
      this.complete = this.number && this.expiry && this.cvc

      // field completed, find field to focus next
      if (this.number) {
        if (!this.expiry) {
          this.$refs.cardExpiry.focus()
        } else if (!this.cvc) {
          this.$refs.cardCvc.focus()
        }
      } else if (this.expiry) {
        if (!this.cvc) {
          this.$refs.cardCvc.focus()
        } else if (!this.number) {
          this.$refs.cardNumber.focus()
        }
      }
      // no focus magic for the CVC field as it gets complete with three
      // numbers, but can also have four
    }
  },
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    number () { this.update() },
    expiry () { this.update() },
    cvc () { this.update() }
  }
}
</script>

<style>
  .stripe-element {
    border: 1px solid #172B4D;
    border-radius: 5px;
    padding: 8px;
  }
</style>
